var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m6.50179 12.808c-.343.812-6.114997 14.372-6.376997 14.961-.361.816.113 1.231.724 1.231h5.112997c.565 0 1.178-.297 1.422-.837.154-.34 2.016-4.704 2.016-4.704.341-.75.566-.969 1.96801-.969h4.57c.633 0 1.048-.346.742-1.064-.247-.583-3.435-8.09-3.706-8.725-.294-.61-.814-.814-1.357-.814h-3.73001c-.6 0-1.064.159-1.385.921zm13.01001-12.046c-.224-.462-.667-.762-1.154-.762h-5.555c-.68 0-1.031.393-1.405 1.247 0 0-2.09301 5.096-2.34001 5.631-.27.59-.022 1.088.77 1.112.034.006 4.41101 0 4.41101 0 .953.008 1.173.605 1.543 1.41l7.832 18.404c.338.758.86 1.196 1.675 1.196h4.891c.94 0 1.053-.721.724-1.48-.296-.685-11.119-26.144-11.392-26.759","fillRule":"evenodd"}));
}

Logo.defaultProps = {"fill":"none","height":"29","viewBox":"0 0 31 29","width":"31"};

module.exports = Logo;

Logo.default = Logo;
